import { useTranslation } from 'react-i18next'
import { Search, X } from 'lucide-react'
import type { KnowledgeLibrarySearchProps } from '@/types/components/knowledge-library-search'

export function KnowledgeLibrarySearch({
  value,
  onChange,
  onAsk,
}: KnowledgeLibrarySearchProps) {
  const { t } = useTranslation('app')
  return (
    <div
      className="flex flex-wrap items-center gap-3"
      data-testid="knowledge-search-row"
    >
      <div
        className="relative flex h-11 min-w-0 flex-1 items-center gap-2.5 rounded-[6px] border border-border bg-card-inset px-3.5 transition-colors focus-within:border-primary/45"
        data-testid="knowledge-search"
      >
        <Search className="h-4 w-4 shrink-0 text-muted-foreground" />
        <input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key !== 'Enter') return
            if (e.nativeEvent.isComposing) return
            e.preventDefault()
            const q = value.trim()
            if (!q) return
            onAsk(q)
          }}
          aria-label={t('library.searchPlaceholder')}
          placeholder={t('library.searchPlaceholder')}
          className="h-full min-w-0 flex-1 bg-transparent text-[15px] text-foreground outline-none placeholder:text-muted-foreground"
          data-testid="knowledge-search-input"
        />
        {value ? (
          <button
            type="button"
            aria-label={t('library.searchClear')}
            className="flex h-6 w-6 items-center justify-center rounded-full text-muted-foreground hover:bg-accent hover:text-foreground"
            data-testid="knowledge-search-clear"
            onClick={() => onChange('')}
          >
            <X className="h-3.5 w-3.5" />
          </button>
        ) : null}
      </div>
    </div>
  )
}
